/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespCollectionsModule_componentModule = {
    readonly title: string | null;
    readonly items: ReadonlyArray<{
        readonly cmsId: number | null;
        readonly title: string | null;
        readonly " $fragmentRefs": FragmentRefs<"HpRespCollectionsModuleItem_item">;
    } | null> | null;
    readonly " $refType": "HpRespCollectionsModule_componentModule";
};
export type HpRespCollectionsModule_componentModule$data = HpRespCollectionsModule_componentModule;
export type HpRespCollectionsModule_componentModule$key = {
    readonly " $data"?: HpRespCollectionsModule_componentModule$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespCollectionsModule_componentModule">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "HpRespCollectionsModule_componentModule",
  "type": "CollectionsModule",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "items",
      "storageKey": null,
      "args": null,
      "concreteType": "Product",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "cmsId",
          "args": null,
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "kind": "FragmentSpread",
          "name": "HpRespCollectionsModuleItem_item",
          "args": null
        }
      ]
    }
  ]
};
})();
(node as any).hash = 'b0b1c9adc3d5b7705a90de1f41b126e6';
export default node;
